// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { Vec3Wire, Vec3WireT } from '../mannequin/vec3-wire';


export class ActorPoseWire implements flatbuffers.IUnpackableObject<ActorPoseWireT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ActorPoseWire {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsActorPoseWire(bb:flatbuffers.ByteBuffer, obj?:ActorPoseWire):ActorPoseWire {
  return (obj || new ActorPoseWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsActorPoseWire(bb:flatbuffers.ByteBuffer, obj?:ActorPoseWire):ActorPoseWire {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ActorPoseWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

uid():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

rootPos(obj?:Vec3Wire):Vec3Wire|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new Vec3Wire()).__init(this.bb_pos + offset, this.bb!) : null;
}

packedQuats(index: number):number|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readUint32(this.bb!.__vector(this.bb_pos + offset) + index * 4) : 0;
}

packedQuatsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

packedQuatsArray():Uint32Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? new Uint32Array(this.bb!.bytes().buffer, this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset), this.bb!.__vector_len(this.bb_pos + offset)) : null;
}

nodeIds(index: number):number|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readUint16(this.bb!.__vector(this.bb_pos + offset) + index * 2) : 0;
}

nodeIdsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

nodeIdsArray():Uint16Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? new Uint16Array(this.bb!.bytes().buffer, this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset), this.bb!.__vector_len(this.bb_pos + offset)) : null;
}

ground():number {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

apex():number {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

scale():number {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

static startActorPoseWire(builder:flatbuffers.Builder) {
  builder.startObject(7);
}

static addUid(builder:flatbuffers.Builder, uid:number) {
  builder.addFieldInt32(0, uid, 0);
}

static addRootPos(builder:flatbuffers.Builder, rootPosOffset:flatbuffers.Offset) {
  builder.addFieldStruct(1, rootPosOffset, 0);
}

static addPackedQuats(builder:flatbuffers.Builder, packedQuatsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, packedQuatsOffset, 0);
}

static createPackedQuatsVector(builder:flatbuffers.Builder, data:number[]|Uint32Array):flatbuffers.Offset;
/**
 * @deprecated This Uint8Array overload will be removed in the future.
 */
static createPackedQuatsVector(builder:flatbuffers.Builder, data:number[]|Uint8Array):flatbuffers.Offset;
static createPackedQuatsVector(builder:flatbuffers.Builder, data:number[]|Uint32Array|Uint8Array):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addInt32(data[i]!);
  }
  return builder.endVector();
}

static startPackedQuatsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addNodeIds(builder:flatbuffers.Builder, nodeIdsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, nodeIdsOffset, 0);
}

static createNodeIdsVector(builder:flatbuffers.Builder, data:number[]|Uint16Array):flatbuffers.Offset;
/**
 * @deprecated This Uint8Array overload will be removed in the future.
 */
static createNodeIdsVector(builder:flatbuffers.Builder, data:number[]|Uint8Array):flatbuffers.Offset;
static createNodeIdsVector(builder:flatbuffers.Builder, data:number[]|Uint16Array|Uint8Array):flatbuffers.Offset {
  builder.startVector(2, data.length, 2);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addInt16(data[i]!);
  }
  return builder.endVector();
}

static startNodeIdsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(2, numElems, 2);
}

static addGround(builder:flatbuffers.Builder, ground:number) {
  builder.addFieldFloat32(4, ground, 0.0);
}

static addApex(builder:flatbuffers.Builder, apex:number) {
  builder.addFieldFloat32(5, apex, 0.0);
}

static addScale(builder:flatbuffers.Builder, scale:number) {
  builder.addFieldFloat32(6, scale, 0.0);
}

static endActorPoseWire(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): ActorPoseWireT {
  return new ActorPoseWireT(
    this.uid(),
    (this.rootPos() !== null ? this.rootPos()!.unpack() : null),
    this.bb!.createScalarList<number>(this.packedQuats.bind(this), this.packedQuatsLength()),
    this.bb!.createScalarList<number>(this.nodeIds.bind(this), this.nodeIdsLength()),
    this.ground(),
    this.apex(),
    this.scale()
  );
}


unpackTo(_o: ActorPoseWireT): void {
  _o.uid = this.uid();
  _o.rootPos = (this.rootPos() !== null ? this.rootPos()!.unpack() : null);
  _o.packedQuats = this.bb!.createScalarList<number>(this.packedQuats.bind(this), this.packedQuatsLength());
  _o.nodeIds = this.bb!.createScalarList<number>(this.nodeIds.bind(this), this.nodeIdsLength());
  _o.ground = this.ground();
  _o.apex = this.apex();
  _o.scale = this.scale();
}
}

export class ActorPoseWireT implements flatbuffers.IGeneratedObject {
constructor(
  public uid: number = 0,
  public rootPos: Vec3WireT|null = null,
  public packedQuats: (number)[] = [],
  public nodeIds: (number)[] = [],
  public ground: number = 0.0,
  public apex: number = 0.0,
  public scale: number = 0.0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const packedQuats = ActorPoseWire.createPackedQuatsVector(builder, this.packedQuats);
  const nodeIds = ActorPoseWire.createNodeIdsVector(builder, this.nodeIds);

  ActorPoseWire.startActorPoseWire(builder);
  ActorPoseWire.addUid(builder, this.uid);
  ActorPoseWire.addRootPos(builder, (this.rootPos !== null ? this.rootPos!.pack(builder) : 0));
  ActorPoseWire.addPackedQuats(builder, packedQuats);
  ActorPoseWire.addNodeIds(builder, nodeIds);
  ActorPoseWire.addGround(builder, this.ground);
  ActorPoseWire.addApex(builder, this.apex);
  ActorPoseWire.addScale(builder, this.scale);

  return ActorPoseWire.endActorPoseWire(builder);
}
}
